export default __webpack_public_path__ + "static/media/bcaa.430cddd1.png";